import React from 'react';

import './NotFound.css';

const NotFound = () => (
  <div className="NotFound">
    <p className="NotFound__codeError">404</p>
    This page doesn't exist
  </div>
);

export default NotFound;
